// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"100":"forgot-password","710":"buyer-registration","966":"login"}[chunkId] || chunkId) + "." + {"100":"98347e2d","268":"32b9281f","710":"a64c4e70","822":"a5ee6179","966":"e5f5f196"}[chunkId] + ".js";
};